if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};
ShopifyAPI.onCartUpdate = function(cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');
};
ShopifyAPI.updateCartNote = function(note, callback) {
    var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + attributeToString(note),
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            }
            else {
                ShopifyAPI.onCartUpdate(cart);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
    };
    jQuery.ajax(params);
};
ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status  + '): ' + data.description);
    }
};
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
    console.log(jQuery(form).serialize());
    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery(form).serialize(),
        dataType: 'json',
        success: function(line_item) {
         
            if ((typeof callback) === 'function') {
               console.log('Add to cart success - callback', line_item);
               fetch('/cart?view=data')
                    .then(response => {
                        if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                        }
                        return response.json(); // Assuming the response is JSON
                    })
                    .then(data => {
                        console.log('Cart Data:', data);
                        callback()
                    })
                    .catch(error => {
                        console.error('Error fetching cart data:', error);
                    });
            }
            else {
              console.log('Add to cart success - item added');
                ShopifyAPI.onItemAdded(line_item, form);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            if ((typeof errorCallback) === 'function') {
                errorCallback(XMLHttpRequest, textStatus);
            }
            else {
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            }
        }
    };
    jQuery.ajax(params);
};
ShopifyAPI.getCart = function(callback) {
    jQuery.get('/cart?view=data', function (cart, textStatus) {
        if ((typeof callback) === 'function') {
          console.log('got cart - callback', JSON.parse(cart));
            callback(JSON.parse(cart));
        }
        else {
            ShopifyAPI.onCartUpdate(cart);
        }
    });
};
ShopifyAPI.changeItem = function(line, quantity, callback) {
    var params = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            // Check if cart only contains the free gift item
            if (cart.item_count === 1 && cart.items[0].id === window.gifCard) {
                // Remove all items from cart
                jQuery.ajax({
                    type: 'POST',
                    url: '/cart/clear.js',
                    dataType: 'json',
                    success: function(clearedCart) {
                        if ((typeof callback) === 'function') {
                            callback(clearedCart);
                        }
                        else {
                            ShopifyAPI.onCartUpdate(clearedCart);
                        }
                    },
                    error: function(XMLHttpRequest, textStatus) {
                        ShopifyAPI.onError(XMLHttpRequest, textStatus);
                    }
                });
            } else {
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
                else {
                    ShopifyAPI.onCartUpdate(cart);
                }
            }

            if (window.gifCard) window.location.reload();
        },
        error: function(XMLHttpRequest, textStatus) {
            ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
    };
    jQuery.ajax(params);
};
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {
    'use strict';
    var init, loadCart;
    var settings, isUpdating, $body;
    var getDiscountPercent;
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;
    var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, getPropertyValue, getPublicProperties, getGiftRule, isFreeGiftCartItem, enrichItemsWithCartData, isFreeGiftQualified, cleanupInvalidFreeGifts;
    var isCleaningInvalidFreeGifts = false;
    var freeGiftRules = {
        gwp1Enabled: false,
        gwp1TriggerCollectionIds: [
            
        ],
        gwp2Enabled: false,
        gwp2Threshold: 15000,
        gwp3Enabled: false,
        gwp3TriggerProductIds: [
            
        ]
    };
    init = function (options) {
        settings = {
            formSelector       : 'form[action^="/cart/add"]',
            cartContainer      : '#cartContainer',
            addToCartSelector  : 'input[type="submit"]',
            cartCountSelector  : null,
            cartCostSelector   : null,
            moneyFormat        : '$',
            disableAjaxCart    : false,
            enableQtySelectors : true
        };
        $.extend(settings, options);
        $formContainer     = $(settings.formSelector);
        $cartContainer     = $(settings.cartContainer);
        $addToCart         = $formContainer.find(settings.addToCartSelector);
        $cartCountSelector = $(settings.cartCountSelector);
        $cartCostSelector  = $(settings.cartCostSelector);
        $body = $('body');
        isUpdating = false;
        if (settings.enableQtySelectors) {
            qtySelectors();
        }
        if (!settings.disableAjaxCart && $addToCart.length) {
            formOverride();
        }
        adjustCart();
    };
    loadCart = function () {
        $body.addClass('ajaxcartIsLoading');
        ShopifyAPI.getCart(cartUpdateCallback);
    };
    getDiscountPercent = function(compareAtPrice, price) {
        if (!compareAtPrice || compareAtPrice <= price) return 0;
        return Math.round((compareAtPrice - price) * 100 / compareAtPrice);
    };
    getPropertyValue = function(properties, propertyName) {
        if (!properties) return null;
        if (properties[propertyName]) return properties[propertyName];

        var propertyValue = null;
        $.each(properties, function(key, value) {
            if (key === propertyName) {
                propertyValue = value;
                return false;
            }
            if ($.isArray(value) && value.length >= 2 && value[0] === propertyName) {
                propertyValue = value[1];
                return false;
            }
            if ($.isPlainObject(value)) {
                var itemKey = value.name || value.key || value[0];
                var itemValue = value.value || value[1];
                if (itemKey === propertyName) {
                    propertyValue = itemValue;
                    return false;
                }
            }
        });

        return propertyValue;
    };
    getPublicProperties = function(properties) {
        if (!properties) return null;

        var publicProperties = {};
        $.each(properties, function(key, value) {
            var propertyKey = String(key);
            var propertyValue = value;

            if ($.isArray(value) && value.length >= 2) {
                propertyKey = String(value[0]);
                propertyValue = value[1];
            }

            if (propertyKey.charAt(0) === '_') return true;
            if (!propertyValue) return true;
            publicProperties[propertyKey] = propertyValue;
        });

        return $.isEmptyObject(publicProperties) ? null : publicProperties;
    };
    getGiftRule = function(cartItem) {
        if (!cartItem) return null;
        return getPropertyValue(cartItem.properties, '_gwp');
    };
    isFreeGiftCartItem = function(cartItem) {
        if (!cartItem) return false;
        return !!getGiftRule(cartItem) || !!getPropertyValue(cartItem.properties, '_free_gift') || !!getPropertyValue(cartItem.properties, '_gift_title');
    };
    enrichItemsWithCartData = function(items, cartDataItems) {
        if (!items || !items.length || !cartDataItems || !cartDataItems.length) return items || [];

        return items.map(function(item) {
            var cartDataItem = cartDataItems.find(function(dataItem) {
                return dataItem.key === item.key;
            });

            if (!cartDataItem) return item;

            return $.extend({}, item, {
                collection_ids: item.collection_ids && item.collection_ids.length ? item.collection_ids : cartDataItem.collection_ids,
                properties: item.properties && !$.isEmptyObject(item.properties) ? item.properties : cartDataItem.properties
            });
        });
    };
    isFreeGiftQualified = function(cartItem, visibleItems, cartSubtotal) {
        var giftRule = getGiftRule(cartItem);

        if (!giftRule) return true;
        if (!visibleItems.length) return false;

        if (giftRule === 'gwp1') {
            if (!freeGiftRules.gwp1Enabled) return false;
            if (!freeGiftRules.gwp1TriggerCollectionIds.length) return false;

            return visibleItems.some(function(item) {
                var collectionIds = item.collection_ids || [];
                return collectionIds.some(function(collectionId) {
                    return freeGiftRules.gwp1TriggerCollectionIds.indexOf(collectionId) !== -1;
                });
            });
        }

        if (giftRule === 'gwp2') {
            return !!freeGiftRules.gwp2Enabled && cartSubtotal >= freeGiftRules.gwp2Threshold;
        }

        if (giftRule === 'gwp3') {
            if (!freeGiftRules.gwp3Enabled || !freeGiftRules.gwp3TriggerProductIds.length) return false;
            return visibleItems.some(function(item) {
                return freeGiftRules.gwp3TriggerProductIds.indexOf(item.product_id) !== -1;
            });
        }

        return true;
    };
    cleanupInvalidFreeGifts = function(cartData, callback, latestCart) {
        var cleanupCart = latestCart || cartData;

        if (isCleaningInvalidFreeGifts || !cleanupCart || !cleanupCart.items || !cleanupCart.items.length) {
            if (typeof callback === 'function') callback(false);
            return;
        }

        var cartDataItems = cartData && cartData.items ? cartData.items : [];
        var cleanupItems = enrichItemsWithCartData(cleanupCart.items, cartDataItems);
        var giftItems = cleanupItems.filter(isFreeGiftCartItem);
        if (!giftItems.length) {
            if (typeof callback === 'function') callback(false);
            return;
        }

        var visibleItems = cleanupItems.filter(function(item) {
            return !isFreeGiftCartItem(item);
        });
        var cartSubtotal = visibleItems.reduce(function(total, item) {
            return total + item.final_line_price;
        }, 0);
        var giftsToRemove = giftItems.filter(function(item) {
            return !isFreeGiftQualified(item, visibleItems, cartSubtotal);
        });

        if (!giftsToRemove.length) {
            if (typeof callback === 'function') callback(false);
            return;
        }

        isCleaningInvalidFreeGifts = true;
        $body.addClass('ajaxcartIsLoading');

        var requests = giftsToRemove.map(function(item) {
            return $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: {
                    id: item.key,
                    quantity: 0
                },
                dataType: 'json'
            });
        });

        $.when.apply($, requests).always(function() {
            isCleaningInvalidFreeGifts = false;
            if (typeof callback === 'function') callback(true);
        });
    };
    updateCountPrice = function (cart) {
        function setCookie(name,value,days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days*24*60*60*1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "")  + expires + "; path=/";
          }

        const cart_count = cart.item_count
        if ($cartCountSelector) {
            $cartCountSelector.html(cart_count).removeClass('hidden-count');
            if (cart_count === 0) {
                $cartCountSelector.addClass('hidden-count');
                setCookie('should_add_free_gift', 'true', 0.5)
            }
        }
        if ($cartCostSelector) {
            $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
        }
    };
    formOverride = function () {
        $formContainer.on('submit', function(evt) {
            evt.preventDefault();
            $addToCart.removeClass('is-added').addClass('is-adding');
          	$('.cart_block').addClass('addcart_block');
            $('.qtyError').remove();
            
        });
    };
    itemAddedCallback = function (product) {
        $addToCart.removeClass('is-adding').addClass('is-added');
      	var $showcart = $('.cart_block').addClass('addcart_block');
      	$("#velaQuickView").fadeOut(100);
        $(".jsQuickview").html("");
        $(".jsQuickview").fadeOut(100);
        setTimeout(function() {
            $showcart.removeClass("addcart_block");
        }, 2500);
        ShopifyAPI.getCart(cartUpdateCallback);
    };
    itemErrorCallback = function (XMLHttpRequest, textStatus) {
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        $addToCart.removeClass('is-adding is-added');
        if (!!data.message) {
            if (data.status == 422) {
                $formContainer.after('<div class="alert alert-danger qtyError">'+ data.description +'</div>')
            }
        }
    };
    cartUpdateCallback = function (cart) {
        updateCountPrice(cart);
        buildCart(cart);
    };
    buildCart = function (cart) {
        $cartContainer.empty();
        if (cart.item_count === 0) {
            $cartContainer
            .append('<p>' + "Your cart is currently empty." + '</p>');
            cartCallback(cart);
            return;
        }
        var items = [],
            item = {},
            data = {},
            source = $("#CartTemplate").html(),
            template = Handlebars.compile(source);
        $.each(cart.items, function(index, cartItem) {
            if (cartItem.image != null){
                var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
            } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            }
            var isFreeGift = !!getPropertyValue(cartItem.properties, '_free_gift');
            var discountPercent = isFreeGift ? 0 : getDiscountPercent(cartItem.compare_at_price, cartItem.final_price);
            item = {
                id: cartItem.variant_id,
                line: index + 1, // Shopify uses a 1+ index in the API
                url: cartItem.url,
                img: prodImg,
                name: cartItem.product_title,
                variation: cartItem.variant_title,
                properties: getPublicProperties(cartItem.properties),
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                price: Shopify.formatMoney(cartItem.final_price, settings.moneyFormat),
                comparePrice: Shopify.formatMoney(cartItem.compare_at_price, settings.moneyFormat),
                isDiscounted: !isFreeGift && cartItem.final_price < cartItem.compare_at_price,
                discountPercent: discountPercent,
                isFreeGift: isFreeGift,
                vendor: cartItem.vendor
            };
            items.push(item);
        });
        data = {
            items: items,
            note: cart.note,
            totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat)
        }
        $cartContainer.append(template(data));
        cartCallback(cart);
    };
    cartCallback = function(cart) {
        $body.removeClass('drawerIsLoading');
        $body.trigger('ajaxCart.afterCartLoad', cart);
    };
    adjustCart = function () {
        $body.on('click', '.qtyAdjust', function() {
            var $el = $(this),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.qtyNum'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));
            var qty = validateQty(qty);
            if ($el.hasClass('qtyPlus')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
            }
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });
        $body.on('change', '.qtyNum', function() {
            var $el = $(this),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));
            var qty = validateQty(qty);
            if (line) {
                updateQuantity(line, qty);
            }
        });
        $body.on('submit', 'form.ajaxcart', function(evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });
        $body.on('focus', '.qtyAdjust', function() {
            var $el = $(this);
            setTimeout(function() {
                $el.select();
            }, 50);
        });
      	$body.on('click', '.cartRemove', function() {
			var $el = $(this),
                line = $el.data('line'),
                qty = 0;
          	if (line) {
                updateQuantity(line, qty);
            }
        });
        function updateQuantity(line, qty) {
            isUpdating = true;
            var $row = $('.ajaxcartRow[data-line="' + line + '"]').addClass('is-loading');
            if (qty === 0) {
                $row.parent().addClass('is-removed');
            }
            setTimeout(function() {
                ShopifyAPI.changeItem(line, qty, adjustCartCallback);
            }, 250);
        }
        $body.on('change', 'textarea[name="note"]', function() {
            var newNote = $(this).val();
            ShopifyAPI.updateCartNote(newNote, function(cart) {});
        });
    };
    adjustCartCallback = function (cart) {
        isUpdating = false;
        setTimeout(function() {
            ShopifyAPI.getCart(function(updatedCart) {
                cleanupInvalidFreeGifts(updatedCart, function(wasCleaned) {
                    if (wasCleaned) {
                        ShopifyAPI.getCart(cartUpdateCallback);
                        return;
                    }

                    cartUpdateCallback(updatedCart);
                }, cart);
            });
        }, 150)
    };
    createQtySelectors = function() {
        if ($('.inject-quantity', $cartContainer).length) {
            $('.inject-quantity', $cartContainer).each(function() {
                var $el = $(this),
                    currentQty = $el.val();
                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;
                var source   = $("#velaAjaxQty").html(),
                template = Handlebars.compile(source),
                data = {
                    id: $el.data('id'),
                    itemQty: itemQty,
                    itemAdd: itemAdd,
                    itemMinus: itemMinus
                };
                $el.after(template(data)).remove();
            });
        }
    };
    qtySelectors = function() {
        var numInputs = $('.inject-quantity');
        if (numInputs.length) {
            numInputs.each(function() {
                var $el = $(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id');
                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;
                var source   = $("#velaJsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        id: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId
                    };
                $el.after(template(data)).remove();
            });
            $('.velaQtyAdjust').on('click', function() {
                var $el = $(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.velaQtyNum'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ''));
                var qty = validateQty(qty);
                if ($el.hasClass('velaQtyAdjustPlus')) {
                    qty += 1;
                } else {
                    qty -= 1;
                    if (qty <= 1) qty = 1;
                }
                $qtySelector.val(qty);
                $el.closest('form').find('.btnUpdateCart').show();
            });
        }
    };
    validateQty = function (qty) {
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {

        } else {
            qty = 1;
        }
        return qty;
    };
    module = {
        init: init,
        load: loadCart,
        refreshCart: buildCart,
        refreshCartCount: updateCountPrice
    };
    return module;
}(ajaxCart || {}, jQuery));
$(document).ready(function() {
	ajaxCart.init({
        formSelector: '.formAddToCart',
        cartContainer: '#cartContainer',
        addToCartSelector: '.btnAddToCart',
        cartCountSelector: '#CartCount',
        cartCostSelector: '#CartCost',
        moneyFormat: window.money
    });
});
